import React, { useState, useRef } from "react"
//import { Container } from "react-bootstrap"

// #region  components
import BreadCrumb from "../../components/Common/Breadcrumb"
import AltaEstudiante from "../Control_Escolar/AltaEstudiante"
import ImageCropComponent  from "../../components/Common/ImageCropComponent"

import { canvasPreview } from './canvasPreview'
import { useDebounceEffect } from './useDebounceEffect'
// #endregion

import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from 'react-image-crop'

import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardImg,
  CardText,
  CardHeader,
  CardImgOverlay,
  CardFooter,
  CardDeck,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  
} from "reactstrap"
import { Link } from "react-router-dom"
import Webcam from "../../components/Common/WebcamComponent"

// This is to demonstate how to make and center a % aspect crop
// which is a bit trickier so we use some helper functions.
function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
  return centerCrop(
    makeAspectCrop(
      {
        unit: '%',
        width: 90,
      },
      aspect,
      mediaWidth,
      mediaHeight,
    ),
    mediaWidth,
    mediaHeight,
  );
}

function centerAspectCrop256(mediaWidth, mediaHeight, aspect) {
  const size = Math.min(mediaWidth, mediaHeight, 256); // Asegurando que el recorte no sea mayor que la imagen o 256px
  return centerCrop(
    {
      unit: 'px', // Cambio de '%' a 'px' para tamaño fijo
      width: size,
      height: size, // Asegurando que el recorte es cuadrado
      aspect: aspect
    },
    mediaWidth,
    mediaHeight,
  );
}

const Testing = () => {

  // #region Internal States
  const [showModalAltaEstudiante, setShowModalAltaEstudiante] = useState(false) 
  const [imgSrc, setImgSrc] = useState('')
  const [showWebcam, setShowWebcam] = useState(false)
  // #endregion

    const toggleAltaEstudiante = () => {
    setShowModalAltaEstudiante(!showModalAltaEstudiante)
  }

  const receiveBase64 = (base64Image) => {
    setImgSrc(base64Image);
  }

  const fnRecibirCropImage = (base64Image) => {
    console.log(base64Image);
  }
  
  const toggleWecamVisibility = () => {
    setShowWebcam(!showWebcam)
  }


  return (
        <div className="page-content">
            {/* Alta Estudiante */}
            <Modal size="xl" isOpen={showModalAltaEstudiante} scrollable={true}>
              <AltaEstudiante onClose={toggleAltaEstudiante}/>
            </Modal>
            <React.Fragment>
                <Container fluid>
                    <BreadCrumb title="" breadcrumbItem={"Index Page"}/>
                        <>
                            <Link
                              to="#!"
                              onClick={() => setShowModalAltaEstudiante(true)}
                              className="btn btn-primary me-1"
                            >
                              Agregar Alumno
                            </Link>

                            <Link onClick={toggleWecamVisibility}><i className="bx bx-camera"></i></Link>

                            <Webcam 
                              isOpen={showWebcam} 
                              onClose={toggleWecamVisibility} 
                              recibe={receiveBase64} 
                              size={{width: 1024, height: 768}}
                            /> 

                            <ImageCropComponent base64={imgSrc} fnRecibirCropImage={fnRecibirCropImage}/>

                        </>
                  </Container>
            </React.Fragment>
        </div>
  )
}
export default Testing
